import React, { useRef, useEffect } from "react";
import { AutoComplete } from "primereact/autocomplete";
import 'primeicons/primeicons.css';
import './StyleSearchGlobal.css'
import { useGlobalSearch } from "./useGlobalSearch";
import BiotechIcon from '@mui/icons-material/Biotech';
import {  Shield } from 'react-feather';

export const GlobalSearch = ({ onSelect }) => {

    const {
        value, setValue, resultsSearch, searchGlobal

    } = useGlobalSearch();
    
    const titleDashboard = localStorage.getItem("title_dashboard") || "Microsanitaria";

    const itemTemplate = (item) => {

      // HEADER
      if (item.isMessage) {
        return (
          <div className="empty-message-custom">
            {item.message}
          </div>
        );
      }

      if (item.isGroup) {

        const isClinico = item.group_id === 1;

        const label = isClinico
          ? "Clínicos"
          : titleDashboard;

       return (
        <div className={`global-group-header ${isClinico ? "clinico" : "sanitario"}`}>
          
         <span className="group-title">
          {isClinico ? (
            <BiotechIcon className="mr-1 group-icon" fontSize="small" />
          ) : (
            // <Shield className="mr-1 group-icon" fontSize="small" />
          <Shield fontSize="x-small" className="group-icon mr-1" />


          )}
          {label}  
        </span>

          <span className="group-count">
            {item.items?.length || 0} Resultados
          </span>
        </div>
      );

    }

      const isCompany = item.type_id === 2;
      const isCancelled = item.id_status === 20;

      const displayName = isCompany
        ? item.company_name
        : item.patient_name;

      return (
        <div className={`global-item ${isCancelled ? "item-cancelled" : ""}`}>

          <div className={`mr-2 global-avatar 
            ${isCancelled 
              ? "cancelled" 
              : isCompany 
                ? "company" 
                : item.gender === "Mujer" 
                  ? "female" 
                  : "male"}
          `}>
            <i className={`${
              isCancelled
                ? "fa fa-ban"
                : isCompany
                  ? "pi pi-building"
                  : "pi pi-user"
            }`}></i>
          </div>

          
        <div className="global-info">

          <div className="info-grid">

            {/* COLUMNA IZQUIERDA */}
            <div className="left-col">
              <span className={`global-nim-badge ${item.type_id === 1 ? "clinico" : "sanitario"}`}>
                {item.nim}
              </span>

              <span className="global-date">
                {item.created_at}
              </span>
            </div>

            {/* COLUMNA DERECHA */}
           <div className="right-col">
              <span className="global-name">
                {displayName}
              </span>

              {isCompany ? (
                <span className="contract-text">
                  {item.contract_number}
                </span>
              ) : (
                <>
                  <span className="global-meta">
                    {item.age || "-"} años • {item.gender || "-"}
                    {item.company_name && ` • ${item.company_name}`}
                  </span>
                </>
              )}
            </div>
              
          </div>
          


        </div>
        </div>
      
      );

    
    };
    const autoCompleteRef = useRef(null);

    // useEffect(() => {
    //   const handleKeyDown = (e) => {
    //     if (e.ctrlKey && e.key.toLowerCase() === "k") {
    //       e.preventDefault();

    //       const input = document.querySelector(".pill-autocomplete input");
    //       if (input) {
    //         input.focus();
    //       }
    //     }
    //   };

    //   window.addEventListener("keydown", handleKeyDown);
    //   return () => window.removeEventListener("keydown", handleKeyDown);
    // }, []);
   

  return (
    <span className="p-input-icon-left global-search-pill">
      <AutoComplete
        ref={autoCompleteRef}
        value={value}
        suggestions={resultsSearch}
        completeMethod={searchGlobal}
        field="nim"
        placeholder="Buscar NIM, etiqueta o paciente..."
        itemTemplate={itemTemplate}
        onChange={(e) => {
          const newValue = e.value;
          setValue(newValue);

          searchGlobal({ query: newValue }, false);
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            searchGlobal({ query: value }, true);
          }
        }}
       onSelect={(e) => {
        const item = e.value;
        if (item.isMessage) return;
        if (item.isGroup) return;
        if (item.id_status === 20) return;
        onSelect(item);
      }}
        onBlur={() => {
          setTimeout(() => {
            setValue("");
          }, 150);
        }}
        className="pill-autocomplete"
      />

     
    </span>
  );
};
